(ns manage.ad-variant.drawer.view
  {:deprecated true}
  ;; Remove after https://app.launchdarkly.com/projects/creative-optimizations/flags/activation-details-side-panel/targeting?env=production&env=test&selected-env=test is on
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Slider$default" :as Slider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/controls/media_player_call/media-pause.svg$default" :as MediaPause]
            ["src/svg/controls/media_player_call/media-play.svg$default" :as MediaPlay]
            ["src/svg/controls/media_player_call/volume-slash.svg$default" :as VolumeSlash]
            ["src/svg/controls/media_player_call/volume-wave-2.svg$default" :as Volume]
            ["src/svg/inform/error-diamond-fill.svg$default" :as ErrorIcon]
            [common.queries :refer [use-infinite-query]]
            [common.widgets.data-grid :as dg]
            [common.widgets.drawer :refer [drawer]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.preview-container :refer [preview-container]]
            [common.widgets.video-timeline :refer [seconds-to-str]]
            [manage.ad-variant-preview.data :as variant-preview-data]
            [manage.ad-variant-preview.hooks :as variant-preview-hooks]
            [manage.ad-variant-preview.viewport :as viewport]
            [manage.ad-variant-preview.widgets.preview-item :refer [preview-content]]
            [manage.ad-variant.data :as variant-data]
            [manage.ad-variant.drawer.db :as db]
            [manage.ad-variant.page.columns :as columns]
            [manage.ad-variant.queries :as q]
            [manage.ad-variant.widgets :as w]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- round-to-nearest-100 [n]
  (* 100 (Math/round (/ n 100))))

(defui video-player-controls [{:keys [variant video-status video-controls]}]
  (let [{:keys [uuid]} variant
        {:keys [playing
                toggle-play
                timeline-disabled
                timeline-progress
                set-timeline-progress
                restore-timeline-progress
                audio-active-variant
                toggle-audio-for-variant
                max-duration]}
        (variant-preview-hooks/use-video-controls {:video-status video-status
                                                   :video-controls video-controls})

        audio-active (= uuid audio-active-variant)]

    ($ Stack
       {:sx #js {:p 1
                 :borderBottom 1
                 :borderColor "grey.60"}}
       ($ Stack
          {:direction "row"
           :justifyContent "space-between"
           :alignItems "center"
           :gap 1}
          ($ Stack
             {:direction "row"
              :alignItems "center"
              :gap 0.5}
             ($ IconButton
                {:onClick toggle-play
                 :size "small"}
                ($ SvgIcon
                   (if playing ($ MediaPause) ($ MediaPlay))))
             ($ Typography
                {:variant "caption"
                 :noWrap true}
                (str (seconds-to-str timeline-progress)
                     " / "
                     (seconds-to-str max-duration))))
          ($ IconButton
             {:onClick (fn []
                         (toggle-audio-for-variant uuid))
              :size "small"}
             ($ SvgIcon
                (if audio-active ($ Volume) ($ VolumeSlash)))))
       ($ Slider
          {:value timeline-progress
           :max max-duration
           :disabled timeline-disabled

           ;; NOTE: most video is probably around 24-30fps, max 120-240fps for some special cases?
           ;; Currently 30fps
           :step (/ 1 30)
           :onChange (fn [_e v]
                       (set-timeline-progress v {:save-position true}))
           :onChangeCommitted restore-timeline-progress

           :sx #js {"& .MuiSlider-track" #js {:transition "none"
                                              :borderWidth 0}
                    "& .MuiSlider-thumb" #js {:transition "none"
                                              :height "12px"
                                              :width "12px"
                                              :visibility "hidden"
                                              "&:hover, &.Mui-active, &.Mui-focusVisible" #js {:boxShadow "none"}}
                    "&:hover .MuiSlider-thumb" #js {:visibility "visible"}}}))))

(defui variant-preview [{:keys [variant hide-variant-info]
                         :or {hide-variant-info false}}]
  (let [{:keys [components ad-type dimensions]} variant
        main-component (variant-data/get-main-component components ad-type)
        [width height] (variant-preview-data/get-card-dimensions
                        {:ad-type ad-type
                         :component main-component
                         :template-dimensions dimensions})
        meta? (variant-data/meta? ad-type)
        video? (= :video (variant-data/get-component-type ad-type))
        carousel? (= :carousel (variant-data/get-component-type ad-type))
        [current-card-has-video? set-current-card-has-video!] (uix/use-state false)
        show-video-controls? (or video? (and carousel? current-card-has-video?))

        event-target (uix/use-ref (js/EventTarget.))
        [video-status set-video-status] (uix/use-state {})
        [video-controls set-video-controls] (uix/use-state {})

        ctx (uix/use-memo (fn []
                            {:event-target @event-target
                             :set-video-controls set-video-controls})
                          [])]

    ($ viewport/CtxProvider
       {:value ctx}
       ($ preview-container
          {:width (cond-> width
                    ;; Since a border is added for meta previews,
                    ;; we need to offset the width with the border width.
                    meta? (+ 2))
           :height (cond-> height
                     ;; The meta height doesn't take into account the extra height
                     ;; that the meta-wrapper adds. We need to offset the height with
                     ;; this extra height of the meta-wrapper to make sure the whole
                     ;; preview is in view.
                     meta? (+ 240))
           ;; This is a bit arbitrary, but it fits all screensizes quite nicely.
           :container-height (round-to-nearest-100 (/ js/window.innerHeight 2))
           :max-zoom 5
           :scroll-zoom-enabled false
           :toolbar-buttons (when-not hide-variant-info
                              ($ w/ad-variant-type-info
                                 {:ad-variant variant}))
           :preview ($ Box {:sx (when meta?
                                  #js {:border "1px solid"
                                       :borderColor "grey.60"})}
                       ($ preview-content
                          {:variant variant
                           :set-video-status set-video-status
                           :video-controls video-controls
                           :on-current-card-video-change set-current-card-has-video!}))
           :preview-controls (when show-video-controls?
                               ($ video-player-controls
                                  {:variant variant
                                   :video-status video-status
                                   :video-controls video-controls}))}))))

(defui variant-errors [{:keys [variant]}]
  (let [{:keys [components]} variant
        errors (keep (fn [[k component]]
                       (when (:error component)
                         [k (get-in component [:error :message 0])])) components)]
    (when (seq errors)
      ($ Alert
         {:severity "error"
          :icon ($ ErrorIcon)}
         ($ AlertTitle "Something went wrong")
         ($ List
            {:sx #js {:listStyleType "disc"
                      :py 0
                      :pl 2}}
            (for [[k message] errors]
              ($ ListItem
                 {:key k
                  :sx #js {:display "list-item"
                           :p 1}}
                 ($ :strong (name k))
                 ($ :br)
                 message)))))))

(defui variant-details [{:keys [variant]}]
  ($ form-field {:label "Status"}
     ($ columns/render-status
        {:status (:ad-variant-status variant)
         :variant variant})))

(defui drawer-content [{:keys [variant]}]
  (let [[current-tab-id set-current-tab-id] (uix/use-state :details)]
    ($ Stack {:gap 2}
       ($ variant-preview
          ;; :key is required to ensure the state within `variant-preview`
          ;; is reset when a new variant is selected.
          {:key (:uuid variant)
           :variant variant})
       ($ Tabs {:value current-tab-id}
          (for [{:keys [id label]} [{:id :details
                                     :label "Details"}]]
            ($ Tab
               {:key id
                :value id
                :onClick (fn [^js _event]
                           (set-current-tab-id id))
                :data-testid (str "tab-" id)
                :label label})))
       (case current-tab-id
         :details ($ :<>
                     ($ variant-errors {:variant variant})
                     ($ variant-details {:variant variant}))
         nil))))

(defui variant-drawer [{:keys [grid-api-ref]}]
  (let [url-context (use-subscribe [:url-context])
        ;; The datagrid's models are needed to get the same response as the datagrid is using.
        models (dg/use-datagrid-models {:api-ref grid-api-ref})
        {{:keys [pages]} :data} (use-infinite-query (q/ad-variants-by-content-id-query
                                                     url-context
                                                     {:field->sort-field columns/field->sort-field
                                                      :field->column columns/field->column
                                                      :field->resolver columns/field->resolver
                                                      :quick-filter {:field (columns/field->column (.-field columns/identifier-column))}}
                                                     models))

        variant-uuid (:variant (use-subscribe [:router/query-parameters]))
        variant (->> pages
                     (mapcat :data)
                     (map :data)
                     (filter #(= (str variant-uuid) (:uuid %)))
                     first)

        on-close #(rf/dispatch [::db/drawer-close])
        open (boolean (and (use-subscribe [::db/drawer-open?]) variant))]
    ($ drawer
       {:open? open
        :on-close on-close
        :label-component ($ Typography
                            {:variant "h3"
                             :noWrap true
                             :sx #js {:pl 1}}
                            (:content-id variant))
        :sx (when open
              #js {:ml 3})}
       (when variant
         ($ drawer-content {:variant variant})))))
